import LoadingOverlay from '~/components/common/LoadingOverlay.vue';
import { generateMetaHead } from '~/utils/head';
export default {
  components: {
    LoadingOverlay
  },
  data() {
    return {
      loaded: false,
      sliderValue: 5000
    };
  },
  head() {
    return generateMetaHead({
      title: 'Cardholder Agreements | Extra'
      // description:
      // 'Ready to get an Extra debit card, but want to read the fine print? Check out our terms of service, privacy policy, card holder agreement, and FCRA notice.',
    });
  }
};